// src/pages/PersonaSelectorPage.tsx
import { useEffect, useState } from 'react';
import { fetchPersonas } from '../api/client';
import { SimBanner } from '../components/SimBanner';
import type { Persona } from '../types';
import styles from './PersonaSelectorPage.module.css';

interface Props { onSelect: (p: Persona) => void; }

export function PersonaSelectorPage({ onSelect }: Props) {
  const [personas, setPersonas] = useState<Persona[]>([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState('');

  useEffect(() => {
    fetchPersonas()
      .then(data => {
        setPersonas(data);
        // If only one persona, auto-select
        if (data.length === 1) onSelect(data[0]);
      })
      .catch(() => setError('Could not load personas. Is the backend running?'))
      .finally(() => setLoading(false));
  }, [onSelect]);

  if (loading) return (
    <div className={styles.screen}>
      <SimBanner />
      <div className={styles.loading}>loading personas...</div>
    </div>
  );

  if (error) return (
    <div className={styles.screen}>
      <SimBanner />
      <div className={styles.error}>{error}</div>
    </div>
  );

  return (
    <div className={styles.screen}>
      <SimBanner />
      <div className={styles.inner}>
        <div className={styles.heading}>
          <div className={styles.eyebrow}>// select_persona.exe</div>
          <h1 className={styles.title}>Choose a Persona</h1>
          <p className={styles.sub}>
            Select the digital persona you would like to converse with.
          </p>
        </div>

        <div className={styles.grid}>
          {personas.map(p => (
            <button key={p.id} className={styles.card} onClick={() => onSelect(p)}>
              <div className={styles.cardAvatar}>{p.avatar_letter}</div>
              <div className={styles.cardName}>{p.display_name}</div>
              <div className={styles.cardDesc}>{p.description}</div>
              <div className={styles.cardCta}>begin conversation →</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
